export default [
  {
    path: '/:accountId',
    name: 'statistics',
    component: () => import('@/views/client/ads-manager/statistics/Statistics.vue'),
    props: route => ({
      accountId: route.params.accountId !== undefined ? parseInt(route.params.accountId, 10) : 0,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Statistics',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Statistics',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/campaign/create/:id?',
    name: 'campaign',
    component: () => import('@/views/client/ads-manager/create/Campaign.vue'),
    props: route => ({
      id: route.params.id !== undefined ? parseInt(route.params.id, 10) : 0,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Create.CreateCampaign',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Create',
          to: '/campaign/create',
        },
        {
          text: 'ClientPortal.SideMenu.Create.CreateCampaign',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/campaign/edit/:id?',
    name: 'campaign',
    component: () => import('@/views/client/ads-manager/create/Campaign.vue'),
    props: route => ({
      id: route.params.id !== undefined ? parseInt(route.params.id, 10) : 0,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Edit.EditCampaign',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Edit',
          to: '/campaign/create',
        },
        {
          text: 'ClientPortal.SideMenu.Edit.EditCampaign',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/adgroup/create/:campaignId?',
    name: 'ad-group',
    component: () => import('@/views/client/ads-manager/create/AdGroup.vue'),
    props: route => ({
      campaignId: route.query.campaignId !== undefined ? parseInt(route.query.campaignId, 10) : 0,
      adGroupId: route.query.adGroupId !== undefined ? parseInt(route.query.adGroupId, 10) : 0,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Create.CreateAdGroup',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Create',
          to: '/adgroup/create',
        },
        {
          text: 'ClientPortal.SideMenu.Create.CreateAdGroup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/adgroup/edit/:campaignId?',
    name: 'ad-group',
    component: () => import('@/views/client/ads-manager/create/AdGroup.vue'),
    props: route => ({
      campaignId: route.query.campaignId !== undefined ? parseInt(route.query.campaignId, 10) : 0,
      adGroupId: route.query.adGroupId !== undefined ? parseInt(route.query.adGroupId, 10) : 0,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Edit.EditAdGroup',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Edit',
          to: '/adgroup/create',
        },
        {
          text: 'ClientPortal.SideMenu.Edit.EditAdGroup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/ad/create/:adId?',
    name: 'ad',
    props: route => ({
      catalogSetId: route.query.catalogSetId !== undefined ? route.query.catalogSetId : '',
      adGroupId: route.query.adGroupId !== undefined ? parseInt(route.query.adGroupId, 10) : 0,
      adId: route.params.adId !== undefined ? parseInt(route.params.adId, 10) : 0,
    }),
    component: () => import('@/views/client/ads-manager/create/ads/Ad.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Create.CreateAd',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Create',
          to: '/ad/create',
        },
        {
          text: 'ClientPortal.SideMenu.Create.CreateAd',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/surveys',
    name: 'surveys',
    component: () => import('@/views/client/ads-manager/surveys/Surveys.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Surveys',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Surveys',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/surveys/create',
    name: 'createSurvey',
    component: () => import('@/views/client/ads-manager/surveys/Create.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Surveys.CreateSurvey',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Surveys',
          to: '/surveys',
        },
        {
          text: 'ClientPortal.SideMenu.Surveys.CreateSurvey',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/surveys/edit/:surveyId',
    name: 'editSurvey',
    component: () => import('@/views/client/ads-manager/surveys/Create.vue'),
    props: route => ({ surveyId: parseInt(route.params.surveyId, 10) }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Surveys.SurveyDetails',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Surveys',
          to: '/surveys',
        },
        {
          text: 'ClientPortal.SideMenu.Surveys.SurveyDetails',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/surveys/details/:surveyId',
    name: 'surveyDetails',
    component: () => import('@/views/client/ads-manager/surveys/Details.vue'),
    props: route => ({ surveyId: parseInt(route.params.surveyId, 10) }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Surveys.SurveyDetails',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Surveys',
          to: '/surveys',
        },
        {
          text: 'ClientPortal.SideMenu.Surveys.SurveyDetails',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/gallery',
    name: 'gallery',
    component: () => import('@/views/client/ads-manager/gallery/Gallery.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Gallery',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Gallery',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/gj/icons',
    name: 'gj-icons',
    component: () => import('@/views/client/GjirafaIcons.vue'),
  },
]
